import type {
  RequiredTargetingSectionKeysType,
  Section,
  TargetingSettingsContextType,
} from '../../../../context/types';

type RestoreDefaultOnClickToSectionArgs = {
  sectionKey: RequiredTargetingSectionKeysType;
  defaultState: Section;
  set: TargetingSettingsContextType['setState'];
};

export const restoreDefaultOnClickToSection = ({
  sectionKey,
  defaultState,
  set,
}: RestoreDefaultOnClickToSectionArgs) => {
  set(prev => {
    const updatedElements = prev.sections[sectionKey].elements.map(element => {
      const defaultElement = defaultState.elements.find(
        defaultElement => defaultElement.mainOption.key === element.mainOption.key
      );

      return {
        mainOption: {
          ...element.mainOption,
          onClick: defaultElement?.mainOption.onClick,
        },
        subOptions:
          element.subOptions?.map(subElement => {
            return {
              ...subElement,
              onClick: defaultElement?.subOptions?.find(defaultSubElement => defaultSubElement.key === subElement.key)
                ?.onClick,
            };
          }) || undefined,
      };
    });

    return {
      ...prev,
      sections: {
        ...prev.sections,
        [sectionKey]: {
          ...prev.sections[sectionKey],
          elements: updatedElements,
        },
      },
    };
  });
};
